export function convertEmailContactsToContacts(conversation, emailContacts) {

  const initialReceiverId = conversation.initialReceiver._id;
  const contacts = [];

  for (let emailContact of emailContacts) {

    const startupUserId = emailContact._id;

    if (startupUserId === initialReceiverId) {
      continue;
    }

    contacts.push({
      name: emailContact.fromName,
      value: emailContact.fromEmailAddress,
      startupUserId,
      _id: emailContact._id,
      profilePicture: emailContact.profilePicture
    });

  }

  return contacts;

}

export function getMessageFragment(messageId) {
  const messageElement = document.getElementById(`message-${messageId}`).querySelector('.inbox-message-group-message-content');
  const vEmailElement = messageElement.querySelector('v-email');

  return vEmailElement?.serializeForEmail() ?? '<span></snap>';
}

export function extractParticipants(conversation, currentUser) {

  const participants = [];

  for (let participant of conversation.participants) {

    if (participant._id === currentUser._id) {
      continue;
    }

    participants.push(participant);

  }

  return participants;

}